import { REDSHIFT_AI_CONNECTOR_FUNCTION_NAME } from "./constants.ts";

/** A published image: its name, a tag, and the digest that tag resolves to. */
type PinnedImage = { imageName: string; tag: string; digest: string };

// copy of packages/integrations/databricks-ai/shared/src/images.ts
/**
 * The image Redshift (AI) runs, pinned to a digest: the connector's, which
 * its install Terraform reads. Move the tag and its digest together. Take the
 * digest from `docker buildx imagetools inspect <name>:<tag>`, the top-level
 * one, not a per-platform digest.
 */
export const RedshiftAiImages = {
  /**
   * The connector's Lambda image. p0-security-perimeter's docker workflow tags
   * each merge to main `sha-<7-character commit SHA>`.
   */
  connector: {
    digest:
      "sha256:b5e6942eced487dfda13d4f59e8e15c32c73acdbc214c2148a02652fb4d15d1f",
    imageName: `p0security/${REDSHIFT_AI_CONNECTOR_FUNCTION_NAME}`,
    tag: "sha-fc85477",
  },
} as const satisfies Record<string, PinnedImage>;
